import { useEffect } from 'react';

function normalizeProjectId(value) {
  return String(value || '').trim();
}

export function resolveProjectRecordId(record = {}) {
  return normalizeProjectId(record?.project_id || record?.id || record?.key);
}

export function selectProjectSlot(projectItems = [], effectiveProjectId = '') {
  const projectId = normalizeProjectId(effectiveProjectId);
  return (Array.isArray(projectItems) ? projectItems : []).find((item) => (
    resolveProjectRecordId(item) === projectId
  )) || null;
}

export function resolveDefaultProjectId(projectItems = []) {
  const firstProject = Array.isArray(projectItems) ? projectItems[0] : null;
  return resolveProjectRecordId(firstProject);
}

function projectListWaitReason(listState) {
  return `project_list_${listState || 'pending'}`;
}

export function resolveProjectRestoreDecision(input) {
  const source = Object(input);
  const current = normalizeProjectId(source.currentProjectId);
  if (current) {
    return { action: 'keep', projectId: current, reason: 'current_project_present' };
  }
  if (source.listState !== 'ready') {
    return { action: 'wait', projectId: '', reason: projectListWaitReason(source.listState) };
  }
  const stored = normalizeProjectId(source.storedProjectId);
  if (selectProjectSlot(source.projectItems, stored)) {
    return { action: 'select', projectId: stored, reason: 'stored_project_visible' };
  }
  if (stored && source.projectHasMore === true) {
    return { action: 'load_more', projectId: '', reason: 'stored_project_not_in_loaded_window' };
  }
  const fallbackProjectId = resolveDefaultProjectId(source.projectItems);
  if (fallbackProjectId) {
    return {
      action: 'select',
      projectId: fallbackProjectId,
      reason: stored ? 'stored_project_invalid_fallback' : 'default_project',
    };
  }
  return { action: 'clear', projectId: '', reason: 'valid_project_absent' };
}

export function useDefaultProjectSelection({
  effectiveProjectId = '',
  projectItems = [],
  setSelectedProjectId,
} = {}) {
  useEffect(() => {
    if (normalizeProjectId(effectiveProjectId) || !Array.isArray(projectItems) || projectItems.length === 0) {
      return;
    }
    const nextProjectId = resolveDefaultProjectId(projectItems);
    if (!nextProjectId) {
      return;
    }
    setSelectedProjectId?.(nextProjectId);
  }, [effectiveProjectId, projectItems, setSelectedProjectId]);
}
